<template>
    <NuxtLayout name="base">
        <ShcUiNotification v-once />
        <slot />
    </NuxtLayout>
</template>

<script setup lang="ts"></script>
